import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { languageOptions } from "../entries";
import { AccountContext } from "../contexts/AccountContexts"
import { MdKeyboardArrowDown } from "react-icons/md";
import { requestChangeLanguagePreference } from "../requests/profile_requests";
import { ContentContext } from "../contexts/ContentContext";
import { darkAndLightThemeDefault } from "./ThemeComponents";


export const detectionOptions = {
    // order and from where user language should be detected
    order: ['navigator', 'querystring', 'cookie', 'localStorage', 'sessionStorage',  'htmlTag', 'path', 'subdomain'],
  
    // keys or params to lookup language from
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,
  
    // cache user language on
    caches: ['localStorage', 'cookie'],
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
  
    // optional expiry and domain for set cookie
    cookieMinutes: 10,
    cookieDomain: 'myDomain',
  
    // optional htmlTag with lang attribute, the default is:
    htmlTag: document.documentElement,
  
    // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
    cookieOptions: { path: '/', sameSite: 'strict' },
  
    // optional conversion function used to modify the detected language code
    convertDetectedLanguage: 'Iso15897',
    convertDetectedLanguage: (lng) => lng.split("-")[0]
  }



export const LanguageDropdown = ({ inPage = false }) => {
    const { i18n } = useTranslation()
    const { user, setUser, language, setLanguage } = useContext(AccountContext)
    const { openErrorModal } = useContext(ContentContext)

    const [open, setOpen] = useState(false)

    const dropdownRef = useRef(null)

    const onLanguageSelect = (lngCode) => {
        setLanguage(lngCode)
        if (user) {
            localStorage.setItem(user.id + "_languagePreference", lngCode)
            requestChangeLanguagePreference({ language: lngCode })
                .then((data) => {
                    // setUser(data.user)
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    openErrorModal(error)
                })
        }
        else {
            localStorage.setItem("anon" + "_languagePreference", lngCode)
        }
        toggleDropdown()
    }

    const toggleDropdown = () => setOpen(!open)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    if (!language) {
        return <></>
    }

    return (
        <div className="relative" ref={dropdownRef}>
            {
                inPage &&
                <div onClick={toggleDropdown} className={`btn btn-sm w-52 h-10 justify-start ${darkAndLightThemeDefault}`} >
                    <img src={languageOptions[language].icon} className="w-8" />
                    <span>{languageOptions[language].name}</span>
                    <div className="ltr:ml-auto rtl:mr-auto">

                        <MdKeyboardArrowDown size={20} />
                    </div>
                </div>
            }
            {
                !inPage &&
                <div onClick={toggleDropdown} className={`btn btn-sm w-10 h-10 rounded-full p-1 border ${darkAndLightThemeDefault}`}><img src={languageOptions[language].icon} className="w-8" /></div>
            }
            {
                open &&
                <ul className={`absolute ltr:right-0 rtl:left-0 menu p-1 bg-white dark:bg-gray-700  rounded-md z-[1] min-w-max max-h-[500px] shadow `}>
                    {
                        Object.values(languageOptions).map((lng) =>

                            <li key={lng.code} className={`${language === lng.code ? "font-bold" : ""} min-w-[200px] ${darkAndLightThemeDefault}`}>
                                <a className="py-1 px-2" onClick={() => onLanguageSelect(lng.code)}>
                                    <img src={lng.icon} className="w-8" />
                                    <span>{lng.name}</span>
                                </a>
                            </li>
                        )
                    }
                </ul>
            }
        </div>
    )
}